import React from 'react';
import { Grid, MenuItem, Stack, } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import { CustomInputLabel, StyledCard, CustomSelect, InputProps, SelectInputProps, CustomTextField } from '../../../../../custom/components';

const CombineAirlineModal = (props) => {

  const isEditMode = Boolean(props.combineAirlineFields?.id);
  const selectedAirlineIds = (props.combineAirlineFields?.temp_airline_list || []).map((id) => Number(id));
  return (
    <div>
      <Stack direction='column' spacing={3}>
        <StyledCard>
          <Grid container spacing={2} rowSpacing={0}>
            <Grid item xs={12} md={12} order={1}>
              <CustomInputLabel htmlFor='name' required>Alliance Name</CustomInputLabel>
              <CustomTextField
                {...InputProps}
                id='name'
                fullWidth
                autoFocus
                placeholder='Alliance Name'
                type='text'
                onChange={props.onChangeCombineAirline}
                name='name'
                value={props.combineAirlineFields.name}
                error={props.combineAirlineErrors.name}
                helperText={props.combineAirlineErrors.name}
              />
            </Grid>

            <Grid item xs={12} lg={6} order={3}>
              <CustomInputLabel htmlFor='code'>Alliance Code</CustomInputLabel>
              <CustomTextField
                {...InputProps}
                id='code'
                fullWidth
                placeholder='Alliance Code'
                type='text'
                onChange={props.onChangeCombineAirline}
                name='code'
                value={props.combineAirlineFields.code}
                error={props.combineAirlineErrors.code}
                helperText={props.combineAirlineErrors.code}
                disabled
              />
            </Grid>
            <Grid item xs={12} lg={6} order={2}>
              <CustomInputLabel htmlFor='airline_list_label' required>Airline Pair</CustomInputLabel>
              <CustomSelect
                multiple
                {...SelectInputProps}
                id='airline_list'
                labelId='airline_list_label'
                fullWidth
                name='airline_list'
                value={props.combineAirlineFields.airline_list || []}
                onChange={props.onChangeCombineAirline}
                classes={{ select: !props.combineAirlineFields.airline_list ? styles.colorPlaceholder : '' }}
              >
                <MenuItem value='placeholder' disabled>Select Airlines</MenuItem>
                {props.airlineList.map((row, i) => (
                  <MenuItem
                    key={i}
                    value={row.id}
                    disabled={row.disabled && !(isEditMode && selectedAirlineIds.includes(Number(row.id)))}
                  >
                    {row.name}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Grid>
          </Grid>
        </StyledCard>

      </Stack>
    </div>
  );
};
export default CombineAirlineModal;